import { panic } from "@opendaw/lib-std";
export const MarkerComparator = (a, b) => {
    const difference = a.position - b.position;
    if (difference === 0) {
        console.warn(a, b);
        return panic("Events at the same position: " + a.position + ", " + b.position);
    }
    return difference;
};
